module.exports = __webpack_public_path__ + "images/40956d69a2468aaf30e63049e00be533-logo_wide.png";